module.exports = "<iframe style=\"border: 0\"  [src]=\"url\" width=\"100%\" height=\"100%\">\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard-providers-external/dashboard-providers-external.component.html
// module id = 2428
// module chunks = 66